import React, { useContext } from 'react'
import styled from 'styled-components'
import { FPS } from '../../../constants'
import ArtboardComponent from '../../artboard'
import { CreationSourceEditorContext } from '../manager'
import Captions from './captions'
import Crop from './crop'
import Watermark from './watermark'

const Artboard = styled(ArtboardComponent)`
    height: 100%;
    left: 0;
    position: absolute;
    top: 0;
    width: 100%;
`

type Props = {
    height: number
    width: number
}

const CreationToolsSourceEditorArtboard = ({ width, height }: Props) => {
    const { source, artboardRef } = useContext(CreationSourceEditorContext)
    const canvasScale = source.width / width

    return (
        <Artboard
            {...{
                fps: FPS,
                ref: artboardRef,
                canvasScale,
                height,
                width,
            }}
        >
            <Captions canvasScale={canvasScale} />
            <Crop canvasScale={canvasScale} />
            <Watermark canvasScale={canvasScale} />
        </Artboard>
    )
}

export default CreationToolsSourceEditorArtboard
